export class TokenEntity {
  accessToken?: string | null
  refreshToken?: string | null
}
